import clsxm from "@/lib/clsxm";
import * as RPNInput from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

type FlagComponentProps = Omit<RPNInput.FlagProps, "countryName"> & {
  countryName?: string;
  className?: string;
};

const FlagComponent = ({country, className, countryName}: FlagComponentProps) => {
  const Flag = flags[country];

  return (
    <span className={clsxm("bg-foreground/20 flex h-5 w-8 overflow-hidden rounded-sm [&_svg]:size-full", className)}>
      {Flag && <Flag title={countryName ?? ""} />}
    </span>
  );
};

export default FlagComponent;
